export default "__VITE_ASSET__ac31a4cd__"